var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdmin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 12 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 .833a3.83 3.83 0 0 1 2.033 7.082 5.17 5.17 0 0 1 3.133 4.752.5.5 0 0 1-1 0 4.167 4.167 0 1 0-8.333 0 .5.5 0 0 1-1 0 5.17 5.17 0 0 1 3.133-4.751A3.834 3.834 0 0 1 6 .833m0 1A2.834 2.834 0 1 0 6.001 7.5 2.834 2.834 0 0 0 6 1.833"
})));
export { SvgAdmin as ReactComponent };
export default __webpack_public_path__ + "static/media/Admin.3971940c.svg";